import 'slick';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from '../gsap-club/gsap-business-green/src/CustomEase';
import { SplitText } from '../gsap-club/gsap-business-green/src/SplitText';
gsap.registerPlugin( ScrollTrigger, CustomEase, SplitText );

/* eslint-disable */
(function ($) {
	let mm = gsap.matchMedia();

	mm.add({
		isMin0: '(min-width: 0px)',
		isMin1024: '(min-width: 1024px)',
		reduceMotion: '(prefers-reduced-motion: reduce)',
	},
		(context) => {
			// context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
			let { isMin0, isMin1024, reduceMotion } = context.conditions;

			const sliderInit = function () {
				$('.testimonial-takeover__items').each(function () {
					const $this = $(this);
					if (1 < $this.children().length) {
						$this.slick({
							arrows: true,
							dots: false,
							infinite: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							speed: 400,
							pauseOnHover: true,
							mobileFirst: true,
							swipe: true,
							fade: true,
							autoplay: false,
							adaptiveHeight: true,
							appendArrows: $(this).parent(),
							prevArrow: '<button class="arrow-left"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none"><path d="M10 17.7143L2 9.35715M2 9.35715L10 1.00001M2 9.35715L14 9.35715L20 9.35715" stroke="black" stroke-width="1.5"/></svg></button>',
							nextArrow: '<button class="arrow-right"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none"><path d="M10 1L18 9.35714M18 9.35714L10 17.7143M18 9.35714L6 9.35714L3.17557e-06 9.35714" stroke="black" stroke-width="1.5"/></svg></button>',
						});


						$('.current').text('1');
						$('.max').text($this[0].slick.slideCount);

						$this.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
							//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
							var slideNumber = nextSlide + 1;
							$('.current').text(slideNumber);
							$('.max').text(slick.slideCount)
						});
					}
				});
			};

			const sliderDestroy = function () {
				if ($('.testimonial-takeover__items.slick-initialized').length) {

					$('.testimonial-takeover__items').slick('unslick');
				}
			};

			/**IF desktop, pin animation ELSE init slick slider**/
			if (isMin1024) {
				//destroy slick
				sliderDestroy();

				//create animation timeline and do animation things
				const tt = document.querySelector('.testimonial-takeover');
				
				if (tt) {
					const tl2 = gsap.timeline( { paused: true } );
					const ttItems = tt.querySelectorAll('.testimonial-takeover__item');
					const ttContentItems = tt.querySelectorAll('.testimonial-takeover__content');
					const ttContentImages = tt.querySelectorAll('.testimonial-takeover__image--desktop img');

					//handle 3 items (admin is allowed 3-5 items for this block)
					if (ttItems.length === 3) {
						tl2.set(ttContentItems[0], {
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						});		
						tl2.set(ttContentImages[0], {
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						});
						tl2.set(ttContentItems[1], {
							autoAlpha: 0.3,
						});
						tl2.set(ttContentImages[1], {
							zIndex: 2,
							autoAlpha: 1,
						});
						tl2.to(ttContentItems[0], {
							delay: 0.2,
							autoAlpha: 0.3,
							y: '-100%',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							ease: "power3.out",
						}, 0.05);		
						tl2.to(ttContentImages[0], {
							autoAlpha: 0.3,
							delay: 0.2,
							y: '-75px',
							x: '-50px',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							zIndex: -1,
							scale: 0.7,
							ease: "power3.out"
						}, 0.05);
						tl2.to(ttContentItems[1], {
							delay: 0.2,
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						}, 0.05);		
						tl2.to(ttContentImages[1], {
							delay: 0.2,
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						}, 0.05);
						tl2.to(ttContentItems[2], {
							autoAlpha: 0.15,
							duration: 0.05,
							delay: 0.2,
						}, 0.05);
						tl2.to(ttContentImages[2], {
							zIndex: 2,
							autoAlpha: 1,
							duration: 0.1,
							delay: 0.15,
						}, 0.1);
						tl2.to(ttContentItems[1], {
							delay: 0.3,
							autoAlpha: 0.3,
							y: '-100%',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							ease: "power3.out"
						}, 0.35);		
						tl2.to(ttContentImages[1], {
							autoAlpha: 0.3,
							delay: 0.3,
							y: '-75px',
							x: '-50px',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							zIndex: -1,
							scale: 0.7,
							ease: "power3.out"
						}, 0.35);
						tl2.to(ttContentItems[0], {
							delay: 0.3,
							autoAlpha: 0,
							y: '-200%',
							duration: 0.05
						}, 0.35);
						tl2.to(ttContentItems[2], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						}, 0.35);		
						tl2.to(ttContentImages[2], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						}, 0.35);
						tl2.from(ttItems, {
							autoAlpha: 1,
							duration: 0.3,
							delay: 0.2
						}, 0.55);
					}


					//handle 4 items
					if (ttItems.length === 4) {
						tl2.set(ttContentItems[0], {
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						});		
						tl2.set(ttContentImages[0], {
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						});
						tl2.set(ttContentItems[1], {
							autoAlpha: 0.3,
						});
						tl2.set(ttContentImages[1], {
							zIndex: 2,
							autoAlpha: 1,
						});
						tl2.to(ttContentItems[0], {
							delay: 0.2,
							autoAlpha: 0.3,
							y: '-100%',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							ease: "power3.out",
						}, 0.05);		
						tl2.to(ttContentImages[0], {
							autoAlpha: 0.3,
							delay: 0.2,
							y: '-75px',
							x: '-50px',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							zIndex: -1,
							scale: 0.7,
							ease: "power3.out"
						}, 0.05);
						tl2.to(ttContentItems[1], {
							delay: 0.2,
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						}, 0.05);		
						tl2.to(ttContentImages[1], {
							delay: 0.2,
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						}, 0.05);
						tl2.to(ttContentItems[2], {
							autoAlpha: 0.3,
							duration: 0.05,
							delay: 0.2,
						}, 0.05);
						tl2.to(ttContentImages[2], {
							zIndex: 2,
							duration: 0.1,
							delay: 0.2,
							autoAlpha: 1,
						}, 0.10);
						tl2.to(ttContentItems[1], {
							delay: 0.3,
							autoAlpha: 0.3,
							y: '-100%',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							ease: "power3.out"
						}, 0.35);		
						tl2.to(ttContentImages[1], {
							autoAlpha: 0.3,
							delay: 0.3,
							y: '-75px',
							x: '-50px',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							zIndex: -1,
							scale: 0.7,
							ease: "power3.out"
						}, 0.35);
						tl2.to(ttContentItems[0], {
							delay: 0.3,
							autoAlpha: 0,
							y: '-200%',
							duration: 0.05
						}, 0.35);
						tl2.to(ttContentItems[2], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						}, 0.35);		
						tl2.to(ttContentImages[2], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						}, 0.35);
						tl2.to(ttContentItems[3], {
							autoAlpha: 0.3,
							duration: 0.05,
							delay: 0.3,
						}, 0.35);
						tl2.to(ttContentImages[3], {
							zIndex: 2,
							autoAlpha: 1,
							duration: 0.1,
							delay: 0.3,
						}, 0.40);
						tl2.to(ttContentItems[2], {
							delay: 0.3,
							autoAlpha: 0.3,
							y: '-100%',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							ease: "power3.out"
						}, 0.65);		
						tl2.to(ttContentImages[2], {
							delay: 0.3,
							autoAlpha: 1,
							y: '-75px',
							x: '-50px',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							zIndex: -1,
							scale: 0.7,
							ease: "power3.out"
						}, 0.65);
						tl2.to(ttContentItems[1], {
							delay: 0.3,
							autoAlpha: 0,
							y: '-200%',
							duration: 0.05
						}, 0.65);
						tl2.to(ttContentItems[3], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						}, 0.65);		
						tl2.to(ttContentImages[3], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						}, 0.65);
						tl2.from(ttItems, {
							autoAlpha: 1,
							duration: 0.25,
							delay: 0.2
						}, 0.85);
					}
					
					//handle 5 items
					if (ttItems.length === 5) {
						tl2.set(ttContentItems[0], {
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						});		
						tl2.set(ttContentImages[0], {
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						});
						tl2.set(ttContentItems[1], {
							autoAlpha: 0.3,
						});
						tl2.set(ttContentImages[1], {
							zIndex: 2,
							autoAlpha: 1,
						});
						tl2.to(ttContentItems[0], {
							delay: 0.2,
							autoAlpha: 0.3,
							y: '-100%',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							ease: "power3.out",
						}, 0.05);		
						tl2.to(ttContentImages[0], {
							autoAlpha: 0.3,
							delay: 0.2,
							y: '-75px',
							x: '-50px',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							zIndex: -1,
							scale: 0.7,
							ease: "power3.out"
						}, 0.05);
						tl2.to(ttContentItems[1], {
							delay: 0.2,
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						}, 0.05);		
						tl2.to(ttContentImages[1], {
							delay: 0.2,
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						}, 0.05);
						tl2.to(ttContentItems[2], {
							autoAlpha: 0.3,
							duration: 0.05,
							delay: 0.2,
						}, 0.05);
						tl2.set(ttContentImages[2], {
							zIndex: 2,
							autoAlpha: 1,
							duration: 0.1,
							delay: 0.2,
						}, 0.1);
						tl2.to(ttContentItems[1], {
							delay: 0.3,
							autoAlpha: 0.3,
							y: '-100%',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							ease: "power3.out"
						}, 0.35);		
						tl2.to(ttContentImages[1], {
							autoAlpha: 0.3,
							delay: 0.3,
							y: '-75px',
							x: '-50px',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							zIndex: -1,
							scale: 0.7,
							ease: "power3.out"
						}, 0.35);
						tl2.to(ttContentItems[0], {
							delay: 0.3,
							autoAlpha: 0,
							y: '-200%',
							duration: 0.05
						}, 0.35);
						tl2.to(ttContentItems[2], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						}, 0.35);		
						tl2.to(ttContentImages[2], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						}, 0.35);
						tl2.to(ttContentItems[3], {
							autoAlpha: 0.3,
							duration: 0.05,
							delay: 0.3,
						}, 0.35);
						tl2.set(ttContentImages[3], {
							zIndex: 2,
							autoAlpha: 1,
							duration: 0.1,
							delay: 0.3,
						}, 0.40);
						tl2.to(ttContentItems[2], {
							delay: 0.3,
							autoAlpha: 0.3,
							y: '-100%',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							ease: "power3.out"
						}, 0.65);		
						tl2.to(ttContentImages[2], {
							delay: 0.3,
							autoAlpha: 1,
							y: '-75px',
							x: '-50px',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							zIndex: -1,
							scale: 0.7,
							ease: "power3.out"
						}, 0.65);
						tl2.to(ttContentItems[1], {
							delay: 0.3,
							autoAlpha: 0,
							y: '-200%',
							duration: 0.05
						}, 0.65);
						tl2.to(ttContentItems[3], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						}, 0.65);		
						tl2.to(ttContentImages[3], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						}, 0.65);
						tl2.to(ttContentItems[4], {
							autoAlpha: 0.3,
							duration: 0.05,
							delay: 0.3,
						}, 0.65);
						tl2.set(ttContentImages[4], {
							zIndex: 2,
							autoAlpha: 1,
							duration: 0.1,
							delay: 0.3,
						}, 0.7);
						tl2.to(ttContentItems[3], {
							delay: 0.3,
							autoAlpha: 0.3,
							y: '-100%',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							ease: "power3.out"
						}, 0.95);		
						tl2.to(ttContentImages[3], {
							delay: 0.3,
							autoAlpha: 1,
							y: '-75px',
							x: '-50px',
							duration: 0.05,
							"--quoteBlur": 6 + 'px',
							zIndex: -1,
							scale: 0.7,
							ease: "power3.out"
						}, 0.95);
						tl2.to(ttContentItems[2], {
							delay: 0.3,
							autoAlpha: 0,
							y: '-200%',
							duration: 0.05
						}, 0.95);
						tl2.to(ttContentItems[4], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							ease: "power3.in"
						}, 0.95);
						tl2.to(ttContentImages[4], {
							delay: 0.3,
							autoAlpha: 1,
							y: 0,
							x: 0,
							duration: 0.05,
							"--quoteBlur": 0 + 'px',
							zIndex: 3,
							scale: 1,
							ease: "power3.in"
						}, 0.95);	
						tl2.from(ttItems, {
							autoAlpha: 1,
							duration: 0.25,
							delay: 0.2,
						}, 1.15);
					}
			
					ScrollTrigger.create({
						animation: tl2,
						trigger: tt,
						pin: true,
						pinnedContainer: tt,
						start: '45% center',
						end: '+=650%',
						scrub: 0.5,
						anticipatePin: 0.5,
					});

					return () => {
						// optionally return a cleanup function that will be called when none of the conditions match anymore (after having matched)
						// it'll automatically call context.revert() - do NOT do that here . Only put custom cleanup code here.
					};
				}

			} else {
				//init slick
				sliderInit();
			}

		});
})(jQuery);
/* eslint-enable */
